"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Pager_1 = __importDefault(require("./Pager"));
exports.default = (function (_a) {
    var paging = _a.paging, showFootPager = _a.showFootPager, rest = __rest(_a, ["paging", "showFootPager"]);
    return react_1.default.createElement("tfoot", null, paging && showFootPager && react_1.default.createElement(Pager_1.default, __assign({}, rest)));
});
//# sourceMappingURL=Footer.js.map


//////////////////
// WEBPACK FOOTER
// .-core/es/components/controls/Grid/Footer.js
// module id = 1931
// module chunks = 0